export default __webpack_public_path__ + "static/media/intro.57cd89ca.md";